export default __webpack_public_path__ + "static/media/circleInfoIcon.d7db4bc9.svg";